<template>
  <div v-if="$props.readonly && modelBlog" class="flex flex-wrap justify-between items-center gap-x-2 gap-y-1 py-4">
    <span v-if="model?.meta?.meta_show_updated_at">Updated at: {{ moment(modelBlog.updated_at).format('YYYY-MM-DD HH:mm') }}</span>

    <div v-if="model?.meta?.meta_show_categories && modelBlog.categories" class="inline-flex flex-wrap gap-2 py-2">
      <UiCategoryBadge
        v-for="(category,c) in modelBlog.categories"
        :key="'category_'+c"
        :text="category"
        @remove="modelBlog.categories.splice(c, 1)"
        />
    </div>

    <ui-link
      v-if="model?.meta?.meta_show_author && modelBlog.author_id && dataAuthorDetails"
      class="inline-flex items-center gap-2"
      :class="{
        'w-full': (!!model?.meta?.meta_show_updated_at) && (!!model?.meta?.meta_show_categories) && modelBlog.categories?.length
      }"
      :to="(dataAuthorDetails?.username ? '/profile/'+dataAuthorDetails?.username : null)"
      :disabled="!dataAuthorDetails?.username"
      >

      by
      <img
        class="rounded-full h-6 aspect-square object-cover"
        :src="(dataAuthorDetails.avatar ?? assetImagePlaceholder)+'?size=50x50'"
        alt="Author avatar"
        >

      {{ dataAuthorDetails?.name ?? 'Anonymous' }}
    </ui-link>

    <div v-if="model?.meta?.meta_show_languages && computedAvailableLanguages.length > 0" class="flex flex-wrap gap-x-4 gap-y-2 items-center w-full py-4">
      <hr class="w-full">
      <b>
        <i class="fas fa-language text-[#111724] mr-2"/>
        Also available in:
      </b>

      <nuxt-link
        v-for="lang in computedAvailableLanguages"
        :key="'lang_'+lang"
        class="flex items-center gap-2 rounded p-1 px-2 bg-white shadow"
        :href="localePath((!!modelBlog?.meta?.i18n?.[lang]?.url) ? modelBlog?.meta?.i18n?.[lang]?.url: modelBlog.url, lang)"
        >
        <span v-text="lang.toUpperCase()" />
        <ui-flag
          class="inline-flex items-center max-h-5 max-w-7 rounded"
          :iso="lang"
          />
      </nuxt-link>
    </div>
  </div>
  <blog-content-edit-wrapper v-else-if="model && !$props.readonly" v-model="model">
    <div v-if="model.meta" class="flex flex-col gap-3 p-3">
      <ui-switch v-model="model.meta.meta_show_updated_at">
        Show updated at
      </ui-switch>
      <ui-switch v-model="model.meta.meta_show_categories">
        Categories
      </ui-switch>
      <ui-switch v-model="model.meta.meta_show_author">
        Show author
      </ui-switch>
      <ui-switch v-model="model.meta.meta_show_languages">
        Show available languages
      </ui-switch>
    </div>
  </blog-content-edit-wrapper>
</template>

<script setup lang="ts">
import moment from 'moment';
import { methodLoadBlogAuthorDetails } from '~/composables/Blog';
import assetImagePlaceholder from '~/assets/img/placeholder-user.png'

defineProps<{ readonly?: boolean }>()

const { locale } = useI18n()
const localePath = useLocalePath()

const model = defineModel<BlogElement>()
const modelBlog = defineModel<Blog>('blog')
const dataAuthorDetails = ref()

onMounted(async () => {
  if(modelBlog.value?.id){
    methodLoadBlogAuthorDetails(modelBlog.value.id).then((res) => {
      dataAuthorDetails.value = res
    })
  }

  if(!model.value){
    model.value = {
      type: 'Meta',
      content: '',
      meta: {} as BlogElementMeta,
      id: 'meta_'+Date.now(),
    } as BlogElement;
  }

  if(!model.value.meta){
    model.value.meta = {
      meta_show_updated_at: true,
      meta_show_categories: true,
      meta_show_author: true,
      meta_show_languages: true,
    } as BlogElementMeta;
  }
})

const computedAvailableLanguages = computed(() => {
  const i18nkeys = (Object.keys(modelBlog.value?.meta?.i18n) as SupportedLanguages[]).filter((key: SupportedLanguages) => {
    return modelBlog?.value?.meta?.i18n?.[key]?.url?.length > 0
      || modelBlog?.value?.meta?.i18n?.[key]?.description?.length > 0
      || modelBlog?.value?.meta?.i18n?.[key]?.title?.length > 0
  })

  i18nkeys.push('en')

  // filter locale.value
  i18nkeys.splice(i18nkeys.indexOf(locale.value), 1)

  return i18nkeys
})
</script>
